'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28.0001 0H6.10352e-05V20H28.0001V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28.0001 0H6.10352e-05V20H28.0001V0Z", fill: "#0637C5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33356 16H25.3336V17.3333H4.00022L5.33356 16ZM15.3336 8C19.3336 5.33333 24.0002 2.66667 24.0002 2.66667C24.0002 2.66667 21.81 6.76459 22.0002 8.66667C22.2545 11.209 25.3336 14.6667 25.3336 14.6667H6.66689C6.66689 14.6667 11.3336 10.6667 15.3336 8Z",
          fill: "#FDD33F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33366 12L4.39085 12.2762L4.66699 11.3334L4.39085 10.3905L5.33366 10.6667L6.27647 10.3905L6.00032 11.3334L6.27647 12.2762L5.33366 12Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66699 3.33335L5.72418 3.6095L6.00032 2.66669L5.72418 1.72388L6.66699 2.00002L7.6098 1.72388L7.33366 2.66669L7.6098 3.6095L6.66699 3.33335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33366 7.33335L8.39085 7.60949L8.66699 6.66669L8.39085 5.72388L9.33366 6.00002L10.2765 5.72388L10.0003 6.66669L10.2765 7.60949L9.33366 7.33335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.66699 7.33335L1.72418 7.60949L2.00032 6.66669L1.72418 5.72388L2.66699 6.00002L3.6098 5.72388L3.33366 6.66669L3.6098 7.60949L2.66699 7.33335Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagTkAsset = forwardRef(FlagTkAsset);

export { VpFlagTkAsset as default };
